import React from "react";
import { Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import { DynictyBrandPanel } from "./DynictyBrandPanel";
import { TenantEmblem } from "./TenantEmblem";
import { MobileDyniHeader } from "./MobileDyniHeader";
import "./dynictyAuth.css";

const DYNICTY_LOGO = "/brand/dynicty-logo-official.webp";

/* Dynicty-owned auth page chrome. `tab` = "login" | "register" | null
   highlights the primary navigation; routes are the existing ones. */
export function DynictyAuthShell({ children, title, subtitle, tab = null, mascot = "welcome" }) {
  const year = new Date().getFullYear();
  return (
    <div className="dyn-auth" data-testid="dynicty-auth-shell">
      <div className="fixed inset-0 pointer-events-none z-0" aria-hidden="true">
        <div className="absolute inset-0 dyn-auth-grid opacity-60" />
        <div className="dyn-auth-blob dyn-pulse-glow -top-32 left-1/4 w-96 h-96" style={{ background: "rgba(6,182,212,0.15)" }} />
        <div className="dyn-auth-blob dyn-pulse-glow bottom-10 right-1/4 w-[450px] h-[450px]" style={{ background: "rgba(147,51,234,0.15)" }} />
        <div className="dyn-auth-blob -bottom-20 left-10 w-80 h-80" style={{ background: "rgba(37,99,235,0.15)" }} />
      </div>

      <main className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
        <div className="w-full max-w-7xl grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <DynictyBrandPanel />

          <section className="lg:col-span-5 flex flex-col items-center w-full min-w-0">
            <MobileDyniHeader variant={mascot} />
            <div className="dyn-glass-card dyn-auth-card w-full max-w-md p-7 sm:p-9 rounded-3xl relative dyn-rise" data-testid="auth-card">
              <div className="flex flex-col items-center text-center">
                <TenantEmblem />
                <h1 className="text-xl sm:text-2xl font-bold text-white mt-4" data-testid="auth-title">{title}</h1>
                {subtitle && <p className="text-xs sm:text-sm mt-1" style={{ color: "#cbd5e1" }} data-testid="auth-subtitle">{subtitle}</p>}
              </div>

              <nav className="dyn-auth-tabs mt-6" aria-label="Navigasi autentikasi" data-testid="auth-tabs">
                <Link to="/login" className="dyn-auth-tab" aria-current={tab === "login" ? "page" : undefined} data-testid="auth-tab-login">
                  <LogIn size={14} /> <span>Login</span>
                </Link>
                <Link to="/register" className="dyn-auth-tab" aria-current={tab === "register" ? "page" : undefined} data-testid="auth-tab-register">
                  <UserPlus size={14} /> <span>Daftar</span>
                </Link>
              </nav>

              <div className="mt-6">{children}</div>

              <div className="mt-8 pt-5 flex flex-col items-center gap-1.5 text-center" style={{ borderTop: "1px solid rgba(255,255,255,0.05)" }}>
                <div className="flex items-center gap-2 text-xs dyn-auth-muted">
                  <span>Powered by</span>
                  <img src={DYNICTY_LOGO} alt="Dynicty" className="h-9 w-auto object-contain" data-testid="powered-by-dynicty" />
                </div>
                <p className="text-[11px] dyn-auth-hint">Solusi E-commerce untuk UMKM &middot; &copy; {year}</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
